import apiClient from '../utils/apiClient';

const virtualTagEndpoint = '/tag/Virtual/tagList';

export const GetVirtualTags = async () => {
  try {
    const response = await apiClient.get(virtualTagEndpoint);
    return response.data; // Virtual tag verilerini döner
  } catch (error) {
    console.error('Error fetching virtual tags:', error);
    throw error;
  }
};
